import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { DailyLeafCollectionRouteWiseSummaryReport } from './Pages';

export const DailyLeafCollectionRouteWiseSummaryReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={DailyLeafCollectionRouteWiseSummaryReport} />
       
    </Fragment>
)